import { useCallback, useEffect, useState } from 'react'
import UserApi from '../api/UserApi'
import { decryptNoteContent, encryptNoteContent, importEncryptionKey } from '../utils/noteCrypto'

const userApi = new UserApi()

export const useNoteEncryption = () => {
    const [encryptionKey, setEncryptionKey] = useState<CryptoKey | null>(null)
    const [isReady, setIsReady] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        let cancelled = false

        const loadEncryptionKey = async () => {
            setIsLoading(true)
            setError(null)

            try {
                const base64Key = await userApi.getNotesEncryptionKey()
                if (cancelled) return

                setEncryptionKey(await importEncryptionKey(base64Key))
                setIsReady(true)
            } catch (err) {
                console.error(err)
                if (!cancelled) {
                    setIsReady(false)
                    setError('Kunde inte ladda krypteringsnyckel för anteckningar.')
                }
            } finally {
                if (!cancelled) {
                    setIsLoading(false)
                }
            }
        }

        void loadEncryptionKey()

        return () => {
            cancelled = true
        }
    }, [])

    const encrypt = useCallback(
        async (plaintext: string) => {
            if (!encryptionKey) {
                throw new Error('Encryption key is not ready.')
            }
            return encryptNoteContent(plaintext, encryptionKey)
        },
        [encryptionKey],
    )

    const decrypt = useCallback(
        async (encryptedContent: string) => {
            if (!encryptionKey) {
                throw new Error('Encryption key is not ready.')
            }
            return decryptNoteContent(encryptedContent, encryptionKey)
        },
        [encryptionKey],
    )

    return {
        decrypt,
        encrypt,
        error,
        isLoading,
        isReady,
    }
}
